import React from 'react';

type Props = {} & React.SVGProps<SVGSVGElement>;

const SvgSmileyPerfect = (props: Props): JSX.Element => {
  return (
    // @ts-ignore
    <svg
      viewBox="0 0 35 35" {...props}
    >
      <path
        d="M17.5.247C7.971.247.247 7.972.247 17.5S7.971 34.753 17.5 34.753c9.528 0 17.253-7.724 17.253-17.253C34.753 7.972 27.028.247 17.5.247zm5.128 9.617a3.219 3.219 0 110 6.437 3.219 3.219 0 010-6.437zm-10.256-.283a3.219 3.219 0 110 6.437 3.219 3.219 0 010-6.437zm14.376 12.564c-.144.172-3.602 4.217-8.791 4.441-3.358.144-6.593-1.324-9.635-4.366a1.176 1.176 0 01.832-2.009l17.452.279c.495.419.559 1.159.142 1.655z"
      />
    </svg>
  );
};

export default SvgSmileyPerfect;
